import { AxiosInstance } from 'axios';
import { useState } from 'react';
import { VideoSourceGenerator } from '../lib/video-source-generator';

export function useVideoSourceGenerator({ api }: { api: AxiosInstance }) {
  return useState(() => new VideoSourceGenerator(api))[0];
}
